var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1355,
    height: 1371,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1024 -224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1395.85 1444.13 1395.85 1595 1129.87 1595 1129.87 1444.13ZM1881.95 1081.85 1881.95 1595 1615.97 1595 1615.97 1081.85ZM2102.07 806.694 2368.05 806.695 2368.06 1595 2102.07 1595ZM2224.82 224.287 2378.12 224.288 2378.12 602.129 2224.81 602.129 2224.81 501.799 1844.1 902.42 1840.68 899.167 1840.68 901.106 1545.86 901.106 1131.15 1303.71 1024.36 1193.71 1482.7 748.752 1487.38 753.579 1487.38 747.798 1779.55 747.798 2130.67 378.316 2010.17 378.317 2010.17 225.008 2224.81 225.008Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIconWhite);
export default __webpack_public_path__ + "static/media/GrowthIcon_white.73aabc200dd47fc98762893b7e9ec344.svg";
export { ForwardRef as ReactComponent };